export const transformArrayIntoChunks = <TData>(
  array: Array<TData>,
  perPage = 50
) =>
  Array.from({ length: Math.ceil(array.length / perPage) }, (value, index) =>
    array.slice(index * perPage, index * perPage + perPage)
  );

interface SingleObject {
  // @ts-ignore
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface CSVHeaders {
  header: string;
  dataKey: string;
}

export const json2csv = <TData extends SingleObject[]>(
  array: TData,
  columns: Array<CSVHeaders>,
  delimiter = ';'
) => {
  const buildHeaders = columns.map((column) => column.header).join(delimiter);
  const buildRows = array.map((arrayChild) => {
    return columns.reduce((acc, key) => {
      return `${acc}${!acc.length ? '' : delimiter}"${
        !arrayChild[key.dataKey] ? '' : arrayChild[key.dataKey]
      }"`;
    }, '');
  });

  return [buildHeaders, ...buildRows].join('\n');
};
